import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode } from 'react'
import { CouponImageSubTitle } from './CouponImageSubTitle'
import { CouponImageTagDefault } from './CouponImageTagDefault'
import { CouponImageTagTicket } from './CouponImageTagTicket'

export interface CouponImageSystemDefaultProps {
  variant?: 'default' | 'ticket'
  titlePrefix: ReactNode
  titleSuffix: ReactNode
  subTitle: ReactNode
}

export const CouponImageSystemDefault = (props: CouponImageSystemDefaultProps) => {
  const { titlePrefix, titleSuffix, subTitle, variant = 'default' } = props
  const isTicket = variant === 'ticket'

  if (isTicket) {
    return (
      <VStack
        minWidth={64}
        height={64}
        userSelect="none"
      >
        <CouponImageTagTicket titlePrefix={titlePrefix} titleSuffix={titleSuffix} />
        <CouponImageSubTitle subTitle={subTitle} />
      </VStack>
    )
  }

  return (
    <VStack
      minWidth={64}
      height={64}
      borderRadius={8}
      borderWidth={1}
      borderStyle="solid"
      borderColor={colors.red600}
      overflow="hidden"
      userSelect="none"
    >
      <CouponImageTagDefault titlePrefix={titlePrefix} titleSuffix={titleSuffix} />
      <CouponImageSubTitle subTitle={subTitle} />
    </VStack>
  )
}
